import { render, staticRenderFns } from "./ElementsForms.vue?vue&type=template&id=162807e3&scoped=true"
import script from "./ElementsForms.vue?vue&type=script&lang=ts"
export * from "./ElementsForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162807e3",
  null
  
)

export default component.exports